module.exports = __webpack_public_path__ + "static/media/arrowRight.6d7eb811.svg";


//////////////////
// WEBPACK FOOTER
// ./src/arrowRight.svg
// module id = 171
// module chunks = 0